import { default as React } from "react";
import { SearchField } from "components/search";
import Multiselect from 'multiselect-react-dropdown';

interface OwnState {
    option: SearchField;
    setValue: (value: any) => void;
    reset: boolean;
    setReset: (value: boolean) => void;
}

type SearchProps = OwnState;

const InputField = ({ option, reset, setReset, setValue }: SearchProps) => {

    let multiselectRef: any;
    React.useEffect(() => {
        if (reset && multiselectRef && multiselectRef.current) {
            multiselectRef.current.resetSelectedValues();
            setReset(false);
        }
    }, [reset]);

    switch (option.type) {
        case "bool":
            return (
                <div style={{ paddingTop: "5px" }}>
                    <input type="radio" id="true" value="true" name={option.parameter} onClick={e => setValue(true)} />
                    <label htmlFor="true">True</label>
                    <input type="radio" id="false" value="false" name={option.parameter} onClick={e => setValue(false)} />
                    <label htmlFor="false">False</label>
                    <input type="radio" id="unset" value="unset" name={option.parameter} onClick={e => setValue(null)} />
                    <label htmlFor="unset">Unset</label>
                </div>
            )
        case "multiselect": {
            multiselectRef = React.createRef<Multiselect>();
            return (
                <Multiselect
                    ref={multiselectRef}
                    options={option?.options}
                    onSelect={(list, v) => setValue(list.map((l: { value: any; }) => l.value))}
                    onRemove={(list, v) => setValue(list.map((l: { value: any; }) => l.value))}
                    showCheckbox={true}
                    closeOnSelect={false}
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                    displayValue="title"
                    style={{
                        'chips': {
                            'fontSize': '8px',
                            'background': '#88a4bf'
                        }
                    }}
                />
            );
        }
        default:
            return <input type="text" onChange={e => setValue(e.currentTarget.value)} style={{ width: '100%' }} />
    }
};

export default InputField;
